import React, { useState } from 'react'
import { IconButton, Stack, Typography } from '@mui/material'
import {
  BoxWithLabel,
  MeasurementFieldController,
  TextfieldControllerProps,
} from '../../../../../common/components'
import CheckIcon from '@mui/icons-material/Check'
import { useFormContext } from 'react-hook-form'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined'

type EditableFieldProps = TextfieldControllerProps & {
  onSave: () => void
}

export const EditableField: React.FC<
  React.PropsWithChildren<EditableFieldProps>
> = ({ label, name, onSave, ...props }) => {
  const { watch } = useFormContext()

  const [isEditing, setEditing] = useState<boolean>(false)

  const saveField = () => {
    onSave()
    setEditing(false)
  }

  return (
    <Stack flex={1} mr={1}>
      <BoxWithLabel size="small" label={label}>
        <Stack
          direction="row"
          alignItems="center"
          height="40px"
          justifyContent="space-between"
        >
          {isEditing ? (
            <>
              <MeasurementFieldController name={name} size="small" {...props} />
              <IconButton size="small" onClick={saveField}>
                <CheckIcon color="success" />
              </IconButton>
            </>
          ) : (
            <>
              <Typography variant="body2">
                {!watch(name).length ? '-' : watch(name)}
              </Typography>

              <IconButton onClick={() => setEditing(true)} sx={{ p: 0 }}>
                <ModeEditOutlineOutlinedIcon color="primary" />
              </IconButton>
            </>
          )}
        </Stack>
      </BoxWithLabel>
    </Stack>
  )
}
